module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Jump"
  }, [_c('p', {
    staticClass: "email"
  }, [_vm._v("\n\t\t我们向你的邮箱 " + _vm._s(' " ' + _vm.UrlParams.mail + ' " ') + " 发出了一封确认信，你需要点击邮箱中的确认链接来完成注册\n  ")]), _vm._v(" "), _c('input', {
    staticClass: "open",
    attrs: {
      "type": "button",
      "value": "打开邮箱查收"
    },
    on: {
      "click": _vm.JumpMail
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Customer"
  }, [_vm._v(" 如有疑问，请联系客服：010-84770602 ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9df25348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/JumpMail.vue
// module id = 776
// module chunks = 1